module.exports = new __parcel__URL__("shop_machines_kuma_ancestor_shrine.01f5810a.png").toString();